import React from 'react';
import PropTypes from 'prop-types';
import InfoExtForm from "./InfoExtForm";
import RegisterFormButton from "./RegisterFormButton";

import withCompose from './RegisterFormTwo.Utils'
import PhoneField from '@xem/look/Renders/Field/Phone'

const RegisterStepTwo = withCompose(
  (props) => {
    let { values, setFieldValue } = props;
    let { phone } = values;

    return (<>
      <PhoneField
        {...props}
        {...{
          value: phone,
          name: 'phone',
          onChange: setFieldValue
        }}
        sx={{ marginTop: '18px', padding: '0 0 15px 0', '& .phone-country':{ marginTop: 'auto', marginBottom: '8px' }}}
      />
      <InfoExtForm {...props} />
      <RegisterFormButton {...props} nextLabel={'user:next'} />
    </>)
  });

RegisterStepTwo.propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  errors: PropTypes.object,
  values: PropTypes.object,
  t: PropTypes.func
};


export default RegisterStepTwo;
